import React, { useEffect, useState } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { getAllPartners } from '../../redux/actions/partner'
import { Table } from 'rsuite'
import CreateOrUpdatePartnerComponent from '../CreateOrUpdatePartnerComponent'
import { checkIsAdminOrModerator } from '../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table

export const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
        <Cell {...props} className="table-action" fixed>
            <div className="button container ps-0 pe-0">
                <button type="button" className={`h4 mb-0 p-2 ps-3 pe-3 text-white rounded bg-green`} onClick={() => onClick(rowData.id)}>Edit</button>
            </div>
        </Cell>
    )
}
const PartnerManageComponent = () => {
    const partnerColumns = [
        { label: 'Partner Name', name: 'partnerName' },
        { label: 'Contact Name', name: 'contactName' },
        { label: 'Address1', name: 'address1' },
        { label: 'Address2', name: 'address2' },
        { label: 'City', name: 'city' },
        { label: 'State', name: 'abbreviatedState' },
        { label: 'Zip', name: 'zip' },
        { label: 'Phone', name: 'phone' },
        { label: 'Email', name: 'email' }
    ]
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [showEditPartnerManagement, setShowEditPartnerManagement] = useState(false)
    const [editPartnerId, setEditPartnerId] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const param = window.location.href.split('partner-manage')[1]
    const history = useHistory()
    const dispatch = useDispatch()
    const store = useStore().getState()
    const { domain } = store
    const { currentDomain } = domain
    const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)

    useEffect(() => {
        setIsLoading(true)
        getAllPartnersData()
    }, [])

    useEffect(() => {
        if (!param) {
            handleHidePartnerManagement()
        }
    }, [param])

    const getAllPartnersData = () => {
        dispatch(getAllPartners()).then((partners) => {
            setTableData(partners)
            setIsLoading(false)
        }).catch(() => {
            setTableData([])
            setIsLoading(false)
        })
    }

    const headerElement = partnerColumns.map((h, index) => {
        return (
            <Column
                resizable
                key={h.name}
            >
                <HeaderCell><h4 className='text-black mb-0 fw-bold'>{h.label}</h4></HeaderCell>
                <Cell className='h4 mb-0 text-black' dataKey={h.name} />
            </Column>
        )
    })

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    }

    const handleEditClick = (partnerId) => {
        setShowEditPartnerManagement(true)
        setEditPartnerId(partnerId)
    }

    const handleHidePartnerManagement = () => {
        // history.push('/partner-manage')
        setShowEditPartnerManagement(false)
        getAllPartnersData()
    }

    const paginatedData = tableData?.sort((a, b) => {
    }).slice(limit * (page - 1), limit * page)

    return (
        !isAdminOrModerator ?
            <h3 className='padding-left text-black mb-0 fw-bold'>You have not permission to view this page</h3>
            :
            <>
                {!showEditPartnerManagement ? (
                    <div className="partner-manage-component padding-left">
                        <div className="partner-table">
                            <div className="record-container quality-child-record">
                                <div className="record-header flex flex-wrap justify-space-between align-center">
                                    <div className="record-title">
                                        <h3 className='mb-0 current-page-title'>Partners</h3>
                                    </div>
                                </div>
                                <div className={`position-relative record-body mt-4 border rounded shadow${isLoading ? ' loading' : ''}`}>
                                    {isLoading && <LoaderComponent />}
                                    <Table
                                        virtualized
                                        autoHeight
                                        affixHeader={true}
                                        data={paginatedData}
                                    >
                                        {headerElement}
                                        <Column
                                            resizable
                                            key="email"
                                        >
                                            <HeaderCell className='d-flex'><h4 className='text-black mb-0 fw-bold'>Action</h4></HeaderCell>
                                            <ActionCell onClick={handleEditClick} />
                                        </Column>
                                    </Table>
                                    <div className='pagination'>
                                        <Pagination
                                            prev
                                            next
                                            first
                                            last
                                            showInfo
                                            maxButtons={5}
                                            lengthMenu={[
                                                {
                                                    label: '5',
                                                    value: 5,
                                                },
                                                {
                                                    label: '10',
                                                    value: 10,
                                                },
                                            ]}
                                            displayLength={limit}
                                            total={tableData?.length}
                                            limit={limit}
                                            activePage={page}
                                            onChangePage={setPage}
                                            onChangeLength={handleChangeLimit}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <CreateOrUpdatePartnerComponent
                        partnerId={editPartnerId}
                        OnHidePartnerManagement={() => { handleHidePartnerManagement() }}
                    />
                )}
            </>
    )
}

export default PartnerManageComponent